module.exports = __webpack_public_path__ + "img/http.a9a434d4.svg";